import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { fontStack } from '../../utils/fontStack';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  position: relative;\n  display: inline-block;\n  width: 100%;\n"], ["\n  ", "\n  position: relative;\n  display: inline-block;\n  width: 100%;\n"])), fontStack);
var templateObject_1;
//# sourceMappingURL=Wrapper.js.map